// export default 'http://localhost:3000';
// export default "http://collab.haveagooday.com.s3-website.eu-west-3.amazonaws.com/";
// export default "https://collab.haveagooday.com";
export default 'https://resident.haveagooday.com';
